<template>
  <div class="news-index">
    <div class="main-inner">
      <main>
        <div class="decrease_account" v-if="corporation.decreaseFlag === true">{{nextMonth}}から利用可能アカウント数が減少いたします。{{deadlineDate}}までに、新しいアカウント数の範囲内でアカウント利用者を設定してください。</div>
        <div class="lead" v-if="this.step == 4">
          <h2 class="headline2">管理者情報変更失敗</h2>
          <p>
            管理者情報変更でエラーが生じました。時間をおいてもう一度お試しください。
          </p>
        </div>
        <div class="lead" v-else-if="this.step == 3">
          <h2 class="headline2">管理者情報変更完了</h2>
          <p>
            ご登録のメールアドレス宛に管理者情報変更完了メールをお送りしました。
            24時間を経過しても管理者情報変更完了メールが届かない場合は、お手数ですが、お問い合わせフォームからお問い合わせいただきますよう、お願いいたします。
          </p>
        </div>
        <div class="lead" v-else-if="this.step == 2">
          <h2 class="headline2">管理者情報変更</h2>
          <p>
            チェックマークの付いた変更内容をご確認のうえ、お間違いがないようであれば、「変更する」ボタンを押してください。
          </p>
        </div>
        <div class="lead" v-else-if="this.step == 1">
          <h2 class="headline2">管理者情報変更</h2>
        </div>
        <div class="lead" v-else>
          <h2 class="headline2">管理者情報</h2>
          <p>
            管理者情報を変更する場合は、下の「変更する」ボタンを押してください。
          </p>
          <p v-if="tempCorporation.paymentMethod !== 2">
            ※管理者とは、ユーザー管理をご担当されている方です。請求書を受け取るご担当者様が変更になる場合は、【お支払い情報】の「請求書記載情報の変更」より変更してください。尚、管理者と請求書を受け取るご担当者様が同一の場合は、【管理者情報】の変更も同時にお願いいたします。
          </p>
          <p v-else>
            ※管理者とは、ユーザー管理をご担当されている方です。クレジットカードの名義人が変更になる場合は、【お支払い情報】の「カード情報の変更」より変更してください。尚、管理者とクレジットカードの名義人が同一の場合は、【管理者情報】の変更も同時にお願いいたします。
          </p>
        </div>
        <section class="list-box" v-if="this.step == 0 || this.step == 2">
          <div class="setting-table">
            <table>
              <tr>
                <th>メールアドレス</th>
                <td>
                  <label>{{ tempCorporation.email }}</label>
                  <span v-if="tempCorporation.email != corporation.email"
                    >&#10003;</span
                  >
                </td>
              </tr>
              <tr>
                <th>業種</th>
                <td>
                  <label>{{ tempCorporation.sectorsName }}</label>
                  <span
                    v-if="
                      tempCorporation.sectorsName != corporation.sectorsName
                    "
                    >&#10003;</span
                  >
                </td>
              </tr>
              <tr>
                <th>貴社名</th>
                <td>
                  <label>{{ tempCorporation.name }}</label>
                  <span v-if="tempCorporation.name != corporation.name"
                    >&#10003;</span
                  >
                </td>
              </tr>
              <tr>
                <th>部署名</th>
                <td>
                  <label>{{ tempCorporation.department }}</label>
                  <span
                    v-if="tempCorporation.department != corporation.department"
                    >&#10003;</span
                  >
                </td>
              </tr>
              <tr>
                <th>ご担当者様お名前</th>
                <td>
                  <label>{{ tempCorporation.officerName }}</label>
                  <span
                    v-if="
                      tempCorporation.officerName != corporation.officerName
                    "
                    >&#10003;</span
                  >
                </td>
              </tr>
              <tr>
                <th>ご担当者様お名前（カナ）</th>
                <td>
                  <label>{{ tempCorporation.officerNameKana }}</label>
                  <span
                    v-if="
                      tempCorporation.officerNameKana !=
                      corporation.officerNameKana
                    "
                    >&#10003;</span
                  >
                </td>
              </tr>
              <tr>
                <th>役職</th>
                <td>
                  <label>{{ tempCorporation.position }}</label>
                  <span v-if="tempCorporation.position != corporation.position"
                    >&#10003;</span
                  >
                </td>
              </tr>
              <tr>
              <tr>
                <th>国・地域</th>
                <td>
                  <label v-if="tempCorporation.country === 0">日本</label>
                  <label v-if="tempCorporation.country === 1">日本以外</label>
                  <span v-if="tempCorporation.country != corporation.country"
                    >&#10003;</span
                  >
                </td>
              </tr>
              <tr v-if="tempCorporation.country === 0">
                <th>郵便番号</th>
                <td>
                  <label>{{ tempCorporation.zipCode }}</label>
                  <span v-if="tempCorporation.zipCode != corporation.zipCode"
                    >&#10003;</span
                  >
                </td>
              </tr>
              <tr>
              <tr v-if="tempCorporation.country === 0">
                <th>都道府県</th>
                <td>
                  <label v-if="tempCorporation.prefectures === '1'">北海道</label>
                  <label v-if="tempCorporation.prefectures === '2'">青森県</label>
                  <label v-if="tempCorporation.prefectures === '3'">岩手県</label>
                  <label v-if="tempCorporation.prefectures === '4'">宮城県</label>
                  <label v-if="tempCorporation.prefectures === '5'">秋田県</label>
                  <label v-if="tempCorporation.prefectures === '6'">山形県</label>
                  <label v-if="tempCorporation.prefectures === '7'">福島県</label>
                  <label v-if="tempCorporation.prefectures === '8'">茨城県</label>
                  <label v-if="tempCorporation.prefectures === '9'">栃木県</label>
                  <label v-if="tempCorporation.prefectures === '10'">群馬県</label>
                  <label v-if="tempCorporation.prefectures === '11'">玉県</label>
                  <label v-if="tempCorporation.prefectures === '12'">千葉県</label>
                  <label v-if="tempCorporation.prefectures === '13'">東京都</label>
                  <label v-if="tempCorporation.prefectures === '14'">神奈川県</label>
                  <label v-if="tempCorporation.prefectures === '15'">新潟県</label>
                  <label v-if="tempCorporation.prefectures === '16'">富山県</label>
                  <label v-if="tempCorporation.prefectures === '17'">石川県</label>
                  <label v-if="tempCorporation.prefectures === '18'">福井県</label>
                  <label v-if="tempCorporation.prefectures === '19'">山梨県</label>
                  <label v-if="tempCorporation.prefectures === '20'">長野県</label>
                  <label v-if="tempCorporation.prefectures === '21'">岐阜県</label>
                  <label v-if="tempCorporation.prefectures === '22'">静岡県</label>
                  <label v-if="tempCorporation.prefectures === '23'">愛知県</label>
                  <label v-if="tempCorporation.prefectures === '24'">三重県</label>
                  <label v-if="tempCorporation.prefectures === '25'">滋賀県</label>
                  <label v-if="tempCorporation.prefectures === '26'">京都府</label>
                  <label v-if="tempCorporation.prefectures === '27'">大阪府</label>
                  <label v-if="tempCorporation.prefectures === '28'">兵庫県</label>
                  <label v-if="tempCorporation.prefectures === '29'">奈良県</label>
                  <label v-if="tempCorporation.prefectures === '30'">和歌山県</label>
                  <label v-if="tempCorporation.prefectures === '31'">鳥取県</label>
                  <label v-if="tempCorporation.prefectures === '32'">島根県</label>
                  <label v-if="tempCorporation.prefectures === '33'">岡山県</label>
                  <label v-if="tempCorporation.prefectures === '34'">広島県</label>
                  <label v-if="tempCorporation.prefectures === '35'">山口県</label>
                  <label v-if="tempCorporation.prefectures === '36'">徳島県</label>
                  <label v-if="tempCorporation.prefectures === '37'">香川県</label>
                  <label v-if="tempCorporation.prefectures === '38'">愛媛県</label>
                  <label v-if="tempCorporation.prefectures === '39'">高知県</label>
                  <label v-if="tempCorporation.prefectures === '40'">福岡県</label>
                  <label v-if="tempCorporation.prefectures === '41'">佐賀県</label>
                  <label v-if="tempCorporation.prefectures === '42'">長崎県</label>
                  <label v-if="tempCorporation.prefectures === '43'">熊本県</label>
                  <label v-if="tempCorporation.prefectures === '44'">大分県</label>
                  <label v-if="tempCorporation.prefectures === '45'">宮崎県</label>
                  <label v-if="tempCorporation.prefectures === '46'">鹿児島県</label>
                  <label v-if="tempCorporation.prefectures === '47'">沖縄県</label>
                  <span v-if="tempCorporation.prefectures != corporation.prefectures"
                    >&#10003;</span
                  >
                </td>
              </tr>
              <tr v-if="tempCorporation.country === 0">
                <th>市区町村番地</th>
                <td>
                  <label>{{ tempCorporation.municipalities }}</label>
                  <span v-if="tempCorporation.municipalities != corporation.municipalities"
                    >&#10003;</span
                  >
                </td>
              </tr>
              <tr v-if="tempCorporation.country === 0">
                <th>建物名・部屋番号</th>
                <td>
                  <label>{{ tempCorporation.building }}</label>
                  <span v-if="tempCorporation.building != corporation.building"
                    >&#10003;</span
                  >
                </td>
              </tr>
              <tr>
                <th>電話番号</th>
                <td>
                  <label>{{ tempCorporation.tel }}</label>
                  <span v-if="tempCorporation.tel != corporation.tel"
                    >&#10003;</span
                  >
                </td>
              </tr>
            </table>
          </div>
          <div class="btn-set" v-if="this.step == 0">
            <span class="btn-gray2">
              <button v-if="tempCorporation.deleteFlag === false" @click="$router.push('withdrawal')">
                退会の手続き
              </button>
              <button @click="inCreaseStep()">変更する</button>
            </span>
          </div>
          <div class="btn-set" v-if="this.step == 2">
            <span class="btn-gray2">
              <button @click="decreseStep()">前の画面に戻る</button>
            </span>
            <span class="btn-gray2">
              <button @click="handleUpdate()">変更する</button>
            </span>
          </div>
        </section>
        <section v-if="this.step == 3">
          <div class="btn-set">
            <span class="btn-gray2">
              <button @click="resetStep()">管理者情報に戻る</button>
            </span>
          </div>
        </section>
        <section v-if="this.step == 4">
          <div class="btn-set">
            <span class="btn-gray2">
              <button  @click="reloadTop()">管理者情報に戻る</button>
            </span>
          </div>
        </section>
        <UpdateAccountSection
          @back="decreseStep"
          @next="inCreaseStep"
          :tempCorporation="tempCorporation"
          v-if="this.step == 1"
        ></UpdateAccountSection>
      </main>
    </div>
  </div>
</template>

<script>
import UpdateAccountSection from '@/components/UpdateAccount.vue'
import { mapActions } from 'vuex'
import httpResource from '../../http/httpResource'
import store from '../../store/index'
export default {
  name: 'Setting',
  components: {
    UpdateAccountSection
  },
  data () {
    return {
      nextMonth: '',
      deadlineDate: '',
      corporation: {},
      tempCorporation: {},
      /* Step0: 法人アカウント情報画面 */
      /* Step1: 法人アカウント情報変更の入力画面 */
      /* Step2: 入力したにようのチェック画面 */
      /* Step3: 変更完了画面 */
      step: 0
    }
  },
  async mounted () {
    let now = new Date()
    let nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1)
    let deadline = new Date(now.getFullYear(), now.getMonth() + 1, 0)
    this.nextMonth = nextMonth.getFullYear() + '年' + (nextMonth.getMonth() + 1) + '月' + nextMonth.getDate() + '日'
    this.deadlineDate = deadline.getFullYear() + '年' + (deadline.getMonth() + 1) + '月' + deadline.getDate() + '日'
    this.reloadData()
  },
  methods: {
    ...mapActions(['login', 'updateCorporation']),
    resetStep () {
      this.step = 0
      window.scrollTo({top: 0})
    },
    inCreaseStep () {
      this.step += 1
      window.scrollTo({top: 0})
    },
    decreseStep () {
      this.step -= 1
      if (this.step === 0) {
        this.tempCorporation = { ...this.corporation }
      }
      window.scrollTo({top: 0})
    },
    async reloadData () {
      try {
        console.log('try')
        const response = await httpResource.get('/corporation/info', {headers: {Authorization: `Bearer ${store.getters.getAuthData.token}`}})
        if (response.status === 200) {
          const data = response.data
          this.corporation = data
          this.tempCorporation = { ...this.corporation }
        }
      } catch (error) {
        console.log(error)
      }
    },
    async handleUpdate () {
      try {
        const response = await httpResource.post(
          '/corporation/users/update-info',
          this.tempCorporation,
          {
            headers: {
              Authorization: `Bearer ${store.getters.getAuthData.token}`
            }
          }
        )
        if (response.status === 200) {
          // jwtトークンを再取得
          const payload = response.data
          this.login(payload.token)
          // アカウント情報がVuexのStoreに更新する
          this.updateCorporation(this.tempCorporation)
          this.reloadData()
          this.inCreaseStep()
        }
      } catch (error) {
        this.inCreaseStep()
        this.inCreaseStep()
        console.log(error)
      }
    },
    reloadTop () {
      this.$router.go({path: this.$router.currentRoute.path, force: true})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/setting/index.vue